package com.dignicate.web.domain

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.StateFlow

class GetTermsUseCase(
    private val repository: ContentRepository,
    scope: CoroutineScope = CoroutineScope(Dispatchers.Default)
) {
    private val fetchTrigger = MutableSharedFlow<Unit>(replay = 1)

    val data: StateFlow<Resource<DocumentContent>> =
        fetchTrigger.mapToResource(
            scope = scope,
            then = { repository.getTerms() }
        )

    suspend fun fetch() {
        fetchTrigger.emit(Unit)
    }
}
